export default "__VITE_ASSET__CN_9iXUG__"